import { useDiscountRulesContext } from "@dashboard/discounts/components/DiscountRules/context";
import { Rule } from "@dashboard/discounts/models";
import { PromotionTypeEnum } from "@dashboard/graphql";
import { Text } from "@saleor/macaw-ui-next";
import React, { Fragment } from "react";
import { useIntl } from "react-intl";

import { messages } from "../../messages";
import { mapConditionToOption, splitConditions } from "../../utils";
import { RuleSummaryChips } from "../RuleSummaryChips";
import { RuleSummaryTooltip } from "../RuleSummaryTooltip";
import { useEnrichConditions } from "./useEnrichConditions";

interface RuleChipsProps {
  rule: Rule;
  currencySymbol: string;
}

export const RuleConditionsChips = ({
  rule,
  currencySymbol,
}: RuleChipsProps) => {
  const intl = useIntl();
  const { discountType } = useDiscountRulesContext();
  const enrichConditions = useEnrichConditions(rule.conditions, currencySymbol);
  // Order rule conditions are saved as an OR list
  const showOr = discountType === PromotionTypeEnum.ORDER;

  const conditions = mapConditionToOption(enrichConditions);

  const { conditionsInSummary, conditionsInTooltip } =
    splitConditions(conditions);

  const hasConditionInTooltip = conditionsInTooltip.length > 0;

  return (
    <>
      {conditionsInSummary.map(({ label, value }, index) => (
        <Fragment key={value}>
          {showOr && index > 0 && (
            <Text marginRight={1.5} data-test-id="rule-summary-or">
              {intl.formatMessage(messages.or)}
            </Text>
          )}
          <RuleSummaryChips value={value} label={label} />
        </Fragment>
      ))}
      {hasConditionInTooltip ? (
        <RuleSummaryTooltip conditionsValues={conditionsInTooltip} />
      ) : null}
    </>
  );
};
